const APP_EVENTS = {
    ADD_TO_CART: 'add_to_cart',
    SLIDER_HIGHLIGH_PRODUCT: 'highlight_product',
    PRODUCT_SHOW_DESCRIPTION: 'product_description'
}
export default APP_EVENTS;
